import { render, staticRenderFns } from "./OrdersTotal.vue?vue&type=template&id=0fd38e2a&scoped=true&"
import script from "./OrdersTotal.vue?vue&type=script&lang=js&"
export * from "./OrdersTotal.vue?vue&type=script&lang=js&"
import style0 from "./OrdersTotal.vue?vue&type=style&index=0&id=0fd38e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd38e2a",
  null
  
)

export default component.exports